import React from "react";
import "./PersonCarousel.css";

export default function PersonCarousel({ items }) {
  const loopItems = [...items, ...items];

  return (
    <div className="pcar-wrapper">
      <div
        className="pcar-center-title"
        data-text="Images of power"
      >
        Images of power
      </div>
      <div className="pcar-track">
        {loopItems.map((item, index) => (
          <a key={index} href={item.link} className="pcar-item">
            <div className={`pcar-image-wrapper ${item.type}`}>
              <img
                src={item.image}
                alt={item.title || ""}
                className="pcar-image"
                loading="lazy"
              />
              {item.title && (
                <div className={`pcar-title ${item.type}`}>{item.title}</div>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
